export default __webpack_public_path__ + "static/media/resgate-cupom.9f89edff.png";